<template>
    <component :is="section.content" @open-modal-for-adolescent-screening="openModal2" />

    <div class="flex flex-wrap my-6 gap-2">
        <button
            v-for="(callout, index) in section.cta"
            :key="index"
            class="bg-green py-4 px-8 shadow rounded-full text-center text-gray-800 font-semibold text-sm flex items-center justify-center gap-2 flex-grow sm:flex-grow-0"
            @click="openModal(callout)"
        >
            <span>{{ callout.buttonTitle }}</span>
            <img class="inline-block h-4 w-4 font-semibold" src="@/assets/img/plus.svg" alt="Plus Icon" />
        </button>
    </div>

    <div v-if="section.reference" class="text-xs mt-2 font-light break-words" v-html="section.reference"></div>

    <ContentModal v-if="isModalVisible" :cta="selectedCta" @close="closeModal" />
    <ContentModal v-if="isModalVisible2" :cta="AdolescentFamilyScreeningData" @close="closeModal2" />
</template>

<script setup>
import { ref, markRaw } from 'vue';
import ContentModal from './ContentModal.vue';
import AdolescentFamilyScreening from './modals/AdolescentFamilyScreening.vue';

defineProps({
    section: {
        type: Object,
        required: true,
    },
});

const isModalVisible = ref(false);
const isModalVisible2 = ref(false);

const AdolescentFamilyScreeningData = {
    title: 'Primary Clinical Manifestations of PH1 Can Look Different in Different Populations',
    subtitle: 'Relative Incidence (%) and Typical Features of PH1 Phenotypes at Initial Presentation',
    slides: [
        {
            title: 'Family Screening',
            subtitle: null,
            content: AdolescentFamilyScreening,
            references:
                'AGXT, alanine-glyoxylate aminotransferase; PH1, Primary Hyperoxaluria Type 1. <br />1. Abukhatwah MW et al. <span class="italic">Medicine (Baltimore)</span> 2020;99:e20371.',
            nextButtonIcon: null,
            nextButtonTitle: '',
            previousButtonTitle: '',
        },
    ],
};

const selectedCta = ref(null);

const openModal = (cta) => {
    selectedCta.value = markRaw(cta);
    isModalVisible.value = true;
};

const closeModal = () => {
    isModalVisible.value = false;
    selectedCta.value = null;
};

const openModal2 = () => {
    isModalVisible2.value = true;
};

const closeModal2 = () => {
    isModalVisible2.value = false;
};
</script>
